<template>
  <!-- Shimmer View -->
   <div class="sg-btm-shimmer" v-if="refundViewType === 'SHIMMER'">
      <div class="shimmer-1"></div>
      <div class="shimmer-2"></div>
      <div class="shimmer-3"></div>
      <div class="shimmer-4"></div>
      <div class="shimmer-overlay"></div>
   </div>
  <!-- Polling View -->
  <div class="sg-btm-wrapper" v-else-if="refundViewType === 'POLLING'">
    <div class="countdown-wrapper">
      <svg class="countdown-ring clockwise" viewBox="0 0 120 120">
        <circle class="ring-bg" cx="60" cy="60" r="54" />
        <circle
          class="ring-progress"
          cx="60"
          cy="60"
          r="54"
          :style="{ strokeDashoffset: strokeOffset }"
        />
      </svg>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" class="countdown-text">
          {{ formattedTime }}
      </text>
    </div>
    <span class="fw-600 fs-20 mb8">{{ countdownLabel }}</span>
    <span class="fw-500 tc color-slaty fs-14">{{ pollingSubtitle }}</span>
  </div>
  <!-- Other Views -->
  <div class="sg-btm-wrapper" v-else >
    <img
      :src="sgTopImage"
      alt="30 minutes delivery"
      width="60px"
      height="60px"
      class=""
      v-if="refundViewType !== 'POLLING' && refundViewType !== 'SUCCESS'"
    />
    <div class="celebrate-confetti-wrapper" v-if="refundViewType === 'SUCCESS' && !confettiCompleted">
      <VueLottiePlayer
          name="celebrate-confetti"
          width=""
          height=""
          :autoplay="true"
          :loop="false"
          :path="
              staticImgBaseUrl +
              '/images/animation/sg-one-celebrate.json'
            "
          @complete="onConfettiComplete"
      />
    </div>
    <div class="refund-confirm-lottie-wrapper" v-if="refundViewType === 'SUCCESS'">
        <VueLottiePlayer
          name="refund-confirm"
          width="30%"
          height="30%"
          :autoplay="true"
          :loop="false"
          :path="
              staticImgBaseUrl +
              '/images/animation/lottie-tick-success.json'
            "
      />
    </div>
    <span class="fw-700 fs-20 mb8 mt12 tc">{{ sgPrimaryText }}</span>
    <span class="mb24 fw-500 tc color-slaty fs-14">{{ sgSecondaryText }}</span>
    <button @click="primaryCtaClick" class="line-btn ripple sg-primary-btn">{{ primaryCtaLabel }}</button>
    <span @click ="secondaryCtaClick" class="fw-600 tc color-secondary fs-12 mt12" v-if="refundViewType!=='INITIATED'">
      {{ secondaryCtaLabel }}
      <i
        class="jfi-arrow-line right color-secondary sg-arrow"
      ></i>
    </span>
  </div>
</template>

<script>
import { keyMapsAction, keyMapsMutation } from '../helpers/storeKeys';
import { projectBasePathWithFolder, v2PwaBasePath, staticImgBaseUrl } from "../config/apiEndpoints";
import localStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { fireSgOneClickAmplitudeEvent } from "../helpers/utility";

export default {
  name: "SgOneClickBottomSheet",
  props: ["sgData"],
  data() {
    return {
      totalTime: 15,
      timeLeft: 15,
      timerInterval: null,
      staticImgBaseUrl: staticImgBaseUrl,
      confettiCompleted: false
    };
  },
  mounted() {
    const timeServiceData = this.sgData?.timeServiceGuarantee || {};
    fireSgOneClickAmplitudeEvent('Click','nextgen home screen', 'click','SG_refund_claim',timeServiceData?.amount, timeServiceData?.type);

    this.$store.commit(keyMapsMutation.UPDATE_IS_SG_BOTTOM_SHEET_OPEN, true);
    this.fireSgOneClickCreateApi();
    const configMs = this.appConfigSgData?.totalPollingTime || 15000;
    const configTime = parseInt(configMs, 10) / 1000;
    if (!isNaN(configTime)) {
      this.totalTime = configTime;
      this.timeLeft = configTime;
    }
  },
  watch: {
    sgPollingStatus(newVal, oldVal) {
      if(newVal !== oldVal) {
        if(newVal === 'I') {
          this.timeLeft = this.totalTime;
          this.startTimer();
        } else if (newVal === 'C' || newVal === 'F' || newVal === 'R') {
          clearInterval(this.timerInterval);
        }
      }
    }
  },
  computed: {
    strokeOffset() {
      const circumference = 2 * Math.PI * 54;
      return circumference - ((this.timeLeft / this.totalTime) * circumference);
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
    countdownLabel() {
      return this.timeLeft <= 5 ? this.appConfigSgData?.title2 || "It’s taking some time..." : this.appConfigSgData?.title1 || "Processing your refund!";
    },
    appConfigSgData() {
      return this.$store.state.Config?.appConfig?.config?.sgOneClickConfig;
    },
    pollingSubtitle() {
      const refundAmt = this.refundAmt;
      let subtitle = this.appConfigSgData?.subTitle || 'Please stay on this screen while we process your wallet refund worth xxxyyy';
      subtitle = subtitle.replace("xxxyyy", `₹${refundAmt}`);
      return subtitle;
    },
    refundAmt() {
      return this.sgData?.timeServiceGuarantee?.amount || 0;
    },
    sgCreateStatus() {
      return this.$store.state.SgOneClick.sgCreateStatus || '';
    },
    sgPollingStatus() {
      return this.$store.state.SgOneClick.sgPollingStatus || '';
    },
    sgStatusData() {
      return this.$store.state.SgOneClick.sgStatusData || {};
    },
    refundViewType() {
      const timeServiceData = this.sgData?.timeServiceGuarantee || {};
      if(!this.sgPollingStatus || !this.sgCreateStatus) {
        return 'SHIMMER';
      }
      if(this.sgCreateStatus === 'SUCCESS') {
        if (this.sgPollingStatus === 'I') { 
          if(this.timeLeft <= 0) {
            fireSgOneClickAmplitudeEvent("screenView", "SG_refund_error_screen", "impression", "SG_refund_claim", timeServiceData?.amount, timeServiceData?.type, "refund initiated and waiting to credit");
            return 'INITIATED';
          }
          return 'POLLING'; 
        } 
        else if (this.sgPollingStatus === 'C') { 
          this.confettiCompleted = false;
          setTimeout(() => {
            this.confettiCompleted = true;
          }, 3000); // Hide after 3 seconds
          fireSgOneClickAmplitudeEvent('screenView', 'SG_refund_confirmation_screen', 'Screen view', 'SG_refund_claim', timeServiceData?.amount, 0, 'Refund credited');
          return 'SUCCESS'; 
        } 
        else if (this.sgPollingStatus === 'F') { 
          fireSgOneClickAmplitudeEvent("screenView", "SG_refund_error_screen", "impression", "SG_refund_claim", timeServiceData?.amount, timeServiceData?.type, "refund failed");
          return 'FAILURE'; 
        }
        else if(this.sgPollingStatus === 'R') { 
          fireSgOneClickAmplitudeEvent("screenView", "SG_refund_error_screen", "impression", "SG_refund_claim", timeServiceData?.amount, timeServiceData?.type, "refund rejected");
          return 'CANCELLED'; 
        }
      }
      else if(this.sgCreateStatus === 'FAILURE') {
        fireSgOneClickAmplitudeEvent("screenView", "SG_refund_error_screen", "impression", "SG_refund_claim", timeServiceData?.amount, timeServiceData?.type, "refund failed");
        return 'FAILURE';
      }
    },
    sgTopImage() {
      if (this.refundViewType === 'INITIATED') {
        return require('../../../default/images/global/sgInitiated.png');
      } else if (this.refundViewType === 'CANCELLED') {
        return require('../../../default/images/global/sgCancelled.png');
      } else if(this.refundViewType === 'FAILURE') {
        return this.sgStatusData?.statusImage || require('../../../default/images/global/sgFail.png');
      }
      return require('../../../default/images/global/sgFail.png');
    },
    sgPrimaryText() {
      if(this.refundViewType === 'FAILURE') {
        return "Oops, we're unable to process your wallet refund!";
      }
      return this.sgStatusData?.title;
    },
    sgSecondaryText() {
      if(this.refundViewType === 'FAILURE') {
        return `You may try again and claim your refund worth ₹${this.refundAmt}`;
      }
      return this.sgStatusData?.subTitle;
    },
    primaryCtaLabel() {
      if(this.refundViewType === 'FAILURE') {
        return "Try Again";
      } else if (this.refundViewType === 'INITIATED') {
        return "Great, Thanks!";
      } else if (this.refundViewType === 'SUCCESS') {
        return "Start Ordering!";
      } else if (this.refundViewType === 'CANCELLED') {
        return "Okay";
      }
      return "Try Again";
    },
    secondaryCtaLabel() {
      if(this.refundViewType === 'FAILURE') {
        return "I'll Do It Later";
      } else if (this.refundViewType === 'INITIATED') {
        return "";
      } else if (this.refundViewType === 'SUCCESS') {
        return "Check Wallet Balance";
      } else if (this.refundViewType === 'CANCELLED') {
        return "Chat With Us";
      }
      return "I'll Do It Later";
    }
  },
  methods: {
    hideBottomSheet() {
      this.$emit('close-bottom-sheet');
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    primaryCtaClick() {
      const timeServiceData = this.sgData?.timeServiceGuarantee || {};
      let eventCategory = this.refundViewType === "FAILURE" ? "Try Again" : this.refundViewType === "CANCELLED" ? 'Okay' : this.refundViewType === "INITIATED" ? "Great, Thanks!": 'Start Ordering';
      let eventLabel = this.refundViewType === "FAILURE" ? "refund failed" : this.refundViewType === "CANCELLED" ? 'refund rejected': this.refundViewType === "INITIATED" ? "refund initiated and waiting to credit" : '';
      let screenName = this.refundViewType === "SUCCESS" ? "SG_refund_confirmation_screen" : "SG_refund_error_screen";
      fireSgOneClickAmplitudeEvent("Click", screenName, "click", eventCategory, timeServiceData?.amount, timeServiceData?.type, eventLabel);
      if(this.refundViewType === 'FAILURE') {
        this.fireSgOneClickCreateApi();
      } else if (this.refundViewType === 'INITIATED') {
        this.hideBottomSheet();
      } else if (this.refundViewType === 'SUCCESS') {
        this.hideBottomSheet();
        // redirect to menu
        let url = 
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
        window.location.href = url;

      } else if (this.refundViewType === 'CANCELLED') {
        this.hideBottomSheet();
      }
    },
    secondaryCtaClick() {
      const timeServiceData = this.sgData?.timeServiceGuarantee || {};
      let eventCategory = this.refundViewType === "FAILURE" ? "I'll do it later" : this.refundViewType === "CANCELLED" ? 'Chat With Us' : 'Check wallet balance';
      let eventLabel = this.refundViewType === "FAILURE" ? "refund failed" : this.refundViewType === "CANCELLED" ? 'refund rejected': "";
      let screenName = this.refundViewType === "SUCCESS" ? "SG_refund_confirmation_screen" : "SG_refund_error_screen";
      fireSgOneClickAmplitudeEvent("Click" ,screenName, "click", eventCategory, timeServiceData?.amount, timeServiceData?.type, eventLabel);
      if(this.refundViewType === 'SUCCESS') {
        this.hideBottomSheet();
        window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}wallet`;
      } else if(this.refundViewType === 'CANCELLED') {
        this.hideBottomSheet();
        sessionStorage.setItem('chatbot_ingress', 'refund_rejected_screen');
        sessionStorage.setItem('chatbotOrderId', this.sgData?.orderId);
        window.location.href = `${v2PwaBasePath}/chatBot`;
      }
       else {
        this.hideBottomSheet();
       }

    },
    fireSgOneClickCreateApi() {
      const wiorderId = this.sgData?.orderId || '';
      const eventId = wiorderId + Date.now();
      this.$store.dispatch(keyMapsAction.SG_ONECLICK_CREATE, {
        wiorderId,
        source: 'ONE_CLICK',
        eventId,
        reasonId: '532',
        aodDiscountType: 'SG',
        clientSource: 'PWA18'
      });
    }
  }
}

</script>